import { CHANGE_DRIVER_LIST } from './constants'

import request from 'utils/request'

import { CLIENT_DRIVERS_URL } from 'constants'


export const driverListChanged = (drivers) => {
  return {
    type: CHANGE_DRIVER_LIST,
    drivers
  }
}


const _fetchDrivers = (dispatch, userId, vehicleId) => {
  request(CLIENT_DRIVERS_URL(userId, vehicleId))
  .then(({drivers}) => {
    dispatch(driverListChanged(drivers))
  })
  .catch((err) => {
    dispatch(driverListChanged([]))
  })
}

export const fetchDrivers = (userId, vehicleId) => {
  return (dispatch) => {
    return _fetchDrivers(dispatch, userId, vehicleId)
  }
}



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Drivers/actions.js